<template>
  <div class="chanel-banner-wrapper banner-wrapper">
    <div class="chanel-logo-border"></div>
    <div class="chanel-logo-wrapper">
      <div class="chanel-logo-svg"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '~settingSCSS';
.chanel-logo-border {
  height: rem-calc(6);
  background-color: $black;
}
.chanel-banner-wrapper {
  height: rem-calc(75);
}
.chanel-logo-wrapper {
  display: flex;
  justify-content: center;
}
.chanel-logo-svg {
  height: rem-calc(20);
  width: 100%;
  padding: 0;
  background: center no-repeat $logo-chanel;
  @include margin(1.5, 0, 1.5, 0);
}
@include breakpoint(large up) {
  .chanel-logo-svg {
    height: rem-calc(29);
    @include margin(4.126, 0, 5.25, 0);
  }
  .chanel-banner-wrapper {
    height: rem-calc(112);
  }
  .chanel-logo-border {
    height: rem-calc(8);
  }
}
</style>
